import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ElectionContact, Round } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-poll-creation-round',
  templateUrl: 'poll-creation-round.component.html',
  styleUrls: ['./poll-creation-round.component.less', '../../../shared/common.less'],
})

export class PollCreationRoundComponent implements OnInit {

  @Input() round: Round;
  @Input() contact: ElectionContact;
  @Input() selectedRound: boolean = true;
  @Output() contactChange = new EventEmitter<ElectionContact>();
  @Output() selectedRoundChange = new EventEmitter<boolean>();

  constructor() {}
  
  onPartialChange() {
  }
  
  onContactChange() {
    this.contactChange.emit(this.contact);
  }

  onRoundChange() {
    this.selectedRoundChange.emit(this.selectedRound);
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  trackByIndex(index: number): number {
    return index;
  }

  
  ngOnInit(): void {
  }
}
